import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Routes } from "./Routs";

const App: React.FC = () => {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </React.Fragment>
  );
};

export default App;
